const MINUTE = 60_000;

/**
 * Read a minute count from the environment.
 *
 * Zero and negative are rejected: react-idle-timer treats a zero timeout as already
 * idle, so a typo in an env file would sign every user out on page load.
 */
export function minutesFromEnv(raw: string | undefined, fallback: number): number {
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

// Authored in the backend env and injected at deploy. These fallbacks are for local runs.
export const SESSION_TIMEOUT_MS = minutesFromEnv(process.env.REACT_APP_SESSION_IDLE_MINUTES, 30) * MINUTE;

export const PROMPT_BEFORE_IDLE_MS = minutesFromEnv(process.env.REACT_APP_SESSION_WARNING_MINUTES, 2) * MINUTE;

export function formatCountdown(ms: number): string {
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}
